import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import * as React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircleOutline";
import { Link } from "react-router-dom";
import {
  useGetCategoriesQuery,
  useGetManufacturersQuery,
  useGetProductsMutation,
} from "../../../../redux/reducer/features/Product/productSlice";
import AppConfirmDialog from "../../../app/AppConfirmDialog";
import { Product } from "../../../../models/features/Product/Product";
import {
  LocationWholegood,
  MatchedProduct,
} from "../../../../models/features/Integration/DmsSetup";
import { useDispatch } from "react-redux";
import {
  addMatchedProduct,
  removeMatchedProduct,
  removeMissMatchProduct,
} from "../../../../redux/reducer/features/Integration/DmsSetupSlice";
import ServerAppGrid from "../../../app/ServerAppGrid";
import { AppFilter, AppFilterItem } from "../../../../models/app/AppModels";
import CloseIcon from "@mui/icons-material/Close";
import styled from "@emotion/styled";
import TruncatedCellWithTooltip from "../../../common/TruncatedCellWithTooltip";

interface MatchManuallyProps {
  isOpen: boolean;
  handleClose: any;
  selectedDmsItems: LocationWholegood[] | undefined;
  setPopup: any;
}

const MatchManually: React.FunctionComponent<MatchManuallyProps> = (props) => {
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const [pagingItems, setPagingItems] = React.useState<AppFilterItem[]>([]);
  const { data, isLoading, isSuccess, refetch, status } =
    useGetCategoriesQuery();
  const dispatch = useDispatch();
  const manufacturers = useGetManufacturersQuery();
  const [selectedCategory, setSelectedCategory] = React.useState("");
  const [selectedSubCategory, setSelectedSubCategory] = React.useState("");
  const [selectedManufacturer, setSelectedManufacturer] = React.useState("");
  const [confirmDialog, setConfirmDialog] = React.useState(false);
  const [selectedCatalogProduct, setSelectedCatalogProduct] =
    React.useState<Product>();
  const [selectedDMSProduct, setSelectedDMSProduct] = React.useState<
    LocationWholegood | undefined
  >();
  const [products, setProducts] = React.useState<any[]>([]);
  const [productsCount, setProductsCount] = React.useState<number>(0);
  const [productsData, productsDataResult] = useGetProductsMutation();

  const categoryDefaultProps = {
    options:
      data && data.entityList
        ? data.entityList.filter((n) => !n.isSubCategory)
        : [],
    getOptionLabel: (option: any) => option.title,
  };

  const manufacturerDefaultProps = {
    options:
      manufacturers.data && manufacturers.data.entityList
        ? manufacturers.data.entityList
        : [],
    getOptionLabel: (option: any) => option.title,
  };
  React.useEffect(() => {
    if (props.selectedDmsItems) {
      setSelectedDMSProduct(props.selectedDmsItems[0]);
    }
  }, [props.selectedDmsItems]);
  const columns: GridColDef[] = [
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      flex: 1,
      filterable: false,
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <TruncatedCellWithTooltip
            value={params.row.productManufacturer.title}
          />
        );
      },
    },
    {
      field: "modelNumber",
      headerName: "Model",
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        return <TruncatedCellWithTooltip value={params.row.modelNumber} />;
      },
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <Link
            to={`/ProductDetail/${params.row.id}`}
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <TruncatedCellWithTooltip value={params.row.title} />
          </Link>
        );
      },
    },
    {
      field: "categoryTitle",
      headerName: "Category",
      flex: 1,
      filterable: false,
      renderCell: (params: GridRenderCellParams<any>) => {
        return <TruncatedCellWithTooltip value={params.row.category.title} />;
      },
    },
    {
      field: "actions",
      headerName: "Match",
      type: "actions",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div>
            <IconButton
              id="basic-button"
              onClick={(n) => {
                setConfirmDialog(true);
                setSelectedCatalogProduct(params.row);
              }}
            >
              <AddCircleIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const fetchData = () => {
    productsData({
      paging: {
        ...paging,
        sectionOnly: false,
        items: [...pagingItems, ...paging.items],
      },
    });
  };

  React.useEffect(() => {
    fetchData();
  }, [paging, pagingItems]);

  React.useEffect(() => {
    if (productsDataResult.data) {
      setProducts(productsDataResult.data.entityList);
      setProductsCount(productsDataResult.data.totalRecords);
    }
  }, [productsDataResult]);

  React.useEffect(() => {
    var categoryTitle = data?.entityList?.find(
      (n) => n.id === selectedCategory,
    );

    if (categoryTitle) {
      var items: AppFilterItem[] = pagingItems;

      var itemToAdd: AppFilterItem = {
        columnField: "categoryTitle",
        operatorValue: "equals",
        value: categoryTitle?.title ?? "",
      };

      if (pagingItems.some((n) => n.columnField === "categoryTitle")) {
        items = items.map((n) =>
          n.columnField === "categoryTitle" ? itemToAdd : n,
        );
        setPagingItems(items);
      } else {
        setPagingItems([...pagingItems, itemToAdd]);
      }
    } else {
      setPagingItems([
        ...pagingItems.filter((n) => n.columnField !== "categoryTitle"),
      ]);
    }
  }, [selectedCategory]);

  React.useEffect(() => {
    var subCategoryTitle = data?.entityList?.find(
      (n) => n.id === selectedSubCategory,
    );

    if (subCategoryTitle) {
      var items: AppFilterItem[] = pagingItems;

      var itemToAdd: AppFilterItem = {
        columnField: "subCategoryTitle",
        operatorValue: "equals",
        value: subCategoryTitle?.title ?? "",
      };

      if (pagingItems.some((n) => n.columnField === "subCategoryTitle")) {
        items = items.map((n) =>
          n.columnField === "subCategoryTitle" ? itemToAdd : n,
        );
        setPagingItems(items);
      } else {
        setPagingItems([...pagingItems, itemToAdd]);
      }
    } else {
      setPagingItems([
        ...pagingItems.filter((n) => n.columnField !== "subCategoryTitle"),
      ]);
    }
  }, [selectedSubCategory]);

  React.useEffect(() => {
    var manufacturer = manufacturers?.data?.entityList?.find(
      (n) => n.id === selectedManufacturer,
    );
    if (manufacturer) {
      var items: AppFilterItem[] = pagingItems;

      var itemToAdd: AppFilterItem = {
        columnField: "manufacturer",
        operatorValue: "equals",
        value: manufacturer?.title ?? "",
      };

      if (pagingItems.some((n) => n.columnField === "manufacturer")) {
        items = items.map((n) =>
          n.columnField === "manufacturer" ? itemToAdd : n,
        );
        setPagingItems(items);
      } else {
        setPagingItems([...pagingItems, itemToAdd]);
      }
    } else {
      setPagingItems([
        ...pagingItems.filter((n) => n.columnField !== "manufacturer"),
      ]);
    }
  }, [selectedManufacturer]);
  const onDialogSuccess = () => {
    props.selectedDmsItems?.forEach((element) => {
      dispatch(removeMatchedProduct({ dmsProduct: element } as MatchedProduct));
      dispatch(
        addMatchedProduct({
          catalogProduct: selectedCatalogProduct as Product,
          dmsProduct: element as LocationWholegood,
          isManuallyMatched: true,
        }),
      );
    });

    props.handleClose();
    setConfirmDialog(false);
    props.setPopup(false);
  };

  const onDialogClose = () => {
    setConfirmDialog(false);
  };

  return (
    <>
      <Dialog
        open={props.isOpen}
        onClose={() => {
          props.handleClose();
        }}
        maxWidth={"lg"}
        fullWidth
        className="check"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 0,
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <Typography sx={{ fontSize: "1.4rem" }}>Match Manually</Typography>
          <IconButton
            onClick={() => {
              props.handleClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Table>
            <TableHead
              sx={{
                position: "sticky",
                zIndex: 1,
                top: 0,
                background: "white",
              }}
            >
              <TableRow sx={{ height: "2vh" }}>
                <TableCell align="left" sx={{ padding: 0, fontWeight: "bold" }}>
                  Manufacturer
                </TableCell>
                <TableCell align="left" sx={{ padding: 0, fontWeight: "bold" }}>
                  Manufacturer Product Number
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ padding: 0, fontWeight: "bold" }}
                >
                  Cost ($)
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ padding: 0, fontWeight: "bold" }}
                >
                  MSRP ($)
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ padding: 0, fontWeight: "bold" }}
                >
                  In Store
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow
                sx={{
                  height: "4vh",
                  backgroundColor: "rgba(0, 0, 0, 0.12)",
                }}
              >
                <TableCell align="left" sx={{ padding: 1 }}>
                  {selectedDMSProduct?.mfrCode +
                    " - " +
                    selectedDMSProduct?.mfgName}
                </TableCell>
                <TableCell align="left" sx={{ padding: 0 }}>
                  {selectedDMSProduct?.model}
                </TableCell>
                <TableCell align="right" sx={{ padding: 0 }}>
                  {selectedDMSProduct?.cost.toFixed(2)}
                </TableCell>
                <TableCell align="right" sx={{ padding: 0 }}>
                  {selectedDMSProduct?.price.toFixed(2)}
                </TableCell>
                <TableCell align="right" sx={{ padding: 1 }}>
                  {selectedDMSProduct?.locationCount?.reduce(
                    (partial: number, value: any) => partial + value.count,
                    0,
                  ) ?? 0}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Grid
            container
            spacing={3}
            justifyContent="space-between"
            display="flex"
            pt={"10px"}
          >
            <Grid item xs={12} sm={6}>
              <Autocomplete
                {...manufacturerDefaultProps}
                id="clear-on-escape"
                clearOnEscape
                loading={isLoading}
                onChange={(e, value) => {
                  setSelectedManufacturer(value?.id ?? "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Manufacturer"
                    variant="standard"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                {...categoryDefaultProps}
                id="clear-on-escape"
                loading={isLoading}
                clearOnEscape
                onChange={(e, value) => {
                  setSelectedCategory(value?.id ?? "");
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Category" variant="standard" />
                )}
              />
            </Grid>
            <Grid item md={12}>
              <ServerAppGrid
                data={products.map((n, i) => ({ id: i, ...n }))}
                columns={columns}
                isLoading={productsDataResult.isLoading}
                paging={paging}
                setPaging={setPaging}
                totalRecords={productsCount}
                height={400}
                hideCheckBoxes={true}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <AppConfirmDialog
        headerText="Are you sure?"
        bodyText="This product will add to Matched Product."
        onFail={onDialogClose}
        onSuccess={onDialogSuccess}
        handleClose={onDialogClose}
        isOpen={confirmDialog}
      />
    </>
  );
};

export default MatchManually;
